import React from "react";
import { SimplePagination } from "../../../../Components/UI/simple-pagination";

export function ApprovalPagination({
  page,
  totalPages,
  onPrev,
  onNext,
  loading = false,
}) {
  return (
    <SimplePagination
      className="mt-8 border-t border-[#EFEFEF] pt-5"
      page={page}
      totalPages={totalPages}
      loading={loading}
      onPageChange={(next) => {
        if (next < page) onPrev();
        else if (next > page) onNext();
      }}
    />
  );
}
